import script from "./CustomerServiceStatsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerServiceStatsView.vue?vue&type=script&setup=true&lang=js"

import "./CustomerServiceStatsView.vue?vue&type=style&index=0&id=0a4b6c3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a4b6c3f"]])

export default __exports__